import React, { useContext, useState } from "react";
import "./ContractUploadPanel.css";
import { DocumentTypeContext } from "../../context/DocumentContext";

interface ContractUploadPanelProps {}

const ContractUploadPanel: React.FC<ContractUploadPanelProps> = (props) => {

  const [filter, setFilter] = useState<string>("Todos");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const {
    tableDocuments,
    getDocuments
  } = useContext(DocumentTypeContext);
  
  const statusMap: { [key: number]: string } = {
    0: "None",
    1: "Novo",
    2: "Aguardando Signatários",
    3: "Aguardando Assinaturas",
    4: "Assinado",
    5: "Finalizado",
    9: "Cancelado",
  };

  const filteredContracts = tableDocuments
    .filter((contract) => {
      if (filter === "Assinados") {
        return contract.status === "Assinado";
      }
      if (filter === "Não Assinados") {
        return contract.status !== "Assinado";
      }
      return true; 
    })
    .filter((contract) => contract.name?.toLowerCase().includes(searchTerm.toLowerCase()))
    .slice(0, 4);

  return (
    <div className="card-right-container">
      <div className="search-section">
        <span className="search-title">PESQUISA RÁPIDA</span>
        <div className="search-bar">
          <input
            type="text"
            placeholder="Procure pelo nome do contrato"
            className="search-input"
            // value={searchTerm}
            onChange={(e) => getDocuments(1, e.target.value, false)} 
          />
        </div>
      </div>

      <div className="contracts-section">
        <span className="contracts-title">SEUS CONTRATOS</span>

        <div className="filters">
          {["Todos", "Assinados", "Não Assinados"].map((status) => (
            <span
              key={status}
              className={`filter ${filter === status ? "active" : ""}`}
              onClick={() => setFilter(status)} 
            >
              {status}
            </span>
          ))}
        </div>

        <div className="contracts-list">
          {filteredContracts.map((contract) => (
            <div key={contract.id} className="contract-item">
              <div className="contract-icon"></div>
              <div className="contract-details">
                <span className="contract-name">{contract.name}</span>
                <span className="contract-status">
                  {statusMap[contract.status]}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContractUploadPanel;
